<template>
  <div>
    <transition name="layout" mode="out-in">
      <div v-if="firstLoading" key="firstLoading" class="first-loading">
        <div class="loading-content">
          努力加载中...
        </div>
      </div>
      <div v-else key="layoutMain" class="layout-main" style="font-size: 16px;">
        <rule-popup :lottery-info="lotteryInfo" />
        <wap-header @lotteryInfo="getLotteryInfo($event)" />
        <div class="wap-content">
          <nuxt />
        </div>
        <wap-footer />
      </div>
    </transition>
  </div>
</template>

<script>
import WapHeader from '@/components/mobile/layout/WapHeader'
import RulePopup from '@/components/mobile/layout/RulePopup'
import WapFooter from '@/components/mobile/layout/WapFooter'
export default {
  name: 'Default',
  components: {
    WapHeader,
    RulePopup,
    WapFooter
  },
  data() {
    return {
      lotteryInfo: {},
      firstLoading: true
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler() {
        this.$store.dispatch('member/checkLocalStorage_mobile')
      }
    }
  },
  mounted() {
    this.$store.dispatch('member/checkLocalStorage_mobile')
    setTimeout(() => {
      this.firstLoading = false
    }, 1000)
  },
  methods: {
    getLotteryInfo(event) {
      this.lotteryInfo = event
    }
  },
  head() {
    return {
      style: [
        { type: 'text/css', cssText: require('@/assets/style/css/main.css') }
      ],
      title: `${this.$store.state.site.siteInfo.siteName}`,
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.$store.state.seo.metaDescription
      }, {
        hid: 'keywords',
        name: 'keywords',
        content: this.$store.state.seo.metaKeyword
      }]
    }
  }

}
</script>

<style lang="scss" scoped>
.first-loading {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eff2f5;

  .loading-content {
    font-size: 30PX;
    color: #666666;
    animation: loading 1.5s linear infinite;
  }
}

@keyframes loading {
  0%   {color: #666666}
  50%  {color: #999999}
  100% {color: #666666}
}
.wap-content {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
